import { useState } from 'react';
import { DonViCoSo, KhachHang, KhoHang, Lo, TaiKhoan, VatTu, ViTri } from '@/types/schemas';

/**
 * Hook for managing search field states in the phieu-xuat-tra-lai-nha-cung-cap feature
 *
 * @returns Object with states and setters for search fields
 */
export const useSearchFieldState = () => {
  // BasicInfoTab fields
  const [customer, setCustomer] = useState<KhachHang | null>(null);
  const [account, setAccount] = useState<TaiKhoan | null>(null);

  // DetailTab fields
  const [vatTu, setVatTu] = useState<VatTu | null>(null);
  const [khoHang, setKhoHang] = useState<KhoHang | null>(null);
  const [lo, setLo] = useState<Lo | null>(null);
  const [viTri, setViTri] = useState<ViTri | null>(null);

  // FilterTab fields
  const [unit, setUnit] = useState<DonViCoSo | null>(null);

  return {
    // BasicInfoTab
    customer,
    setCustomer,
    account,
    setAccount,
    // DetailTab
    vatTu,
    setVatTu,
    khoHang,
    setKhoHang,
    lo,
    setLo,
    viTri,
    setViTri,
    // FilterTab
    unit,
    setUnit
  };
};
